module.exports = __webpack_public_path__ + "static/scene-6.8382cecf.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/scene-6.png
// module id = 305
// module chunks = 2